import { useState, useEffect } from 'react';
import { breakpoints } from 'utils/breakpoint';
const useCheckRWD = () => {
    const [rwd, setRwd] = useState('PC');

    const handleRWD = () => {
        if (window.screen.width > breakpoints.lg) setRwd('xlg');
        else if (window.screen.width > breakpoints.md) setRwd('lg');
        else if (window.screen.width > breakpoints.sm) setRwd('md');
        else if (window.screen.width > breakpoints.xsm) setRwd('sm');
        else setRwd('xsm');
    };

    useEffect(() => {
        window.addEventListener('resize', handleRWD);
        handleRWD();

        return () => {
            window.removeEventListener('resize', handleRWD);
        };
    }, []);

    return rwd;
};
export default useCheckRWD;

export const useControlcss = countImgItems => {
    if (useCheckRWD() === 'xsm') {
        if (countImgItems === 2) {
            return `max-width: 176px;`;
        } else {
            return `max-width: 264px;`;
        }
    } else {
        if (countImgItems < 9 && countImgItems > 4) {
            return `max-width: 440px;`;
        } else if (countImgItems > 8) {
            return `max-width: 704px;`;
        } else if (countImgItems === 2) {
            return `max-width: 176px;`;
        } else if (countImgItems === 3) {
            return `max-width: 264px;`;
        } else if (countImgItems === 4) {
            return `max-width: 352px;`;
        }
    }
};

export const useToShowSlider = countImgItems => {
    if (useCheckRWD() === 'xsm') {
        if (countImgItems === 2) {
            return 2;
        } else {
            return 3;
        }
    } else {
        if (countImgItems < 9 && countImgItems > 4) {
            return 5;
        } else if (countImgItems > 8) {
            return 8;
        } else if (countImgItems === 2) {
            return 2;
        } else if (countImgItems === 3) {
            return 3;
        } else if (countImgItems === 4) {
            return 4;
        }
    }
};
